"use client";

import Image from "next/image";
import { useLocale } from "@/lib/locale-context";

export default function Logo({
  variant = "dark",
  className = "",
}: {
  variant?: "dark" | "light";
  className?: string;
}) {
  const { locale } = useLocale();

  // Английская версия сайта — отдельный цельный EN-логотип:
  //  • variant "light" (тёмный фон, hero) → белый autopilot_white.png
  //  • variant "dark"  (светлый фон)      → цветной Autopilot_logo.png
  if (locale === "en") {
    const src = variant === "light" ? "/autopilot_white.png" : "/Autopilot_logo.png";
    return (
      <div className={`flex h-[32px] items-center ${className}`} aria-label="AUTOPILOT TRANSPORT COMPANY">
        <Image src={src} alt="AUTOPILOT" width={164} height={32} priority className="h-[32px] w-auto object-contain" />
      </div>
    );
  }

  // Русская версия — прежняя сборка из SVG (знак + две строки текста).
  // Исходные SVG залиты светлым (#F1F3F6) — для тёмного hero (variant "light").
  // Для светлых под-страниц (variant "dark") берём цветные копии: знак синий,
  // текст серый — чтобы логотип не был белым и читался на светлом фоне.
  const colored = variant === "dark";
  const mark = colored ? "/logo/logo-mark-color.svg" : "/logo/logo-mark.svg";
  const t1 = colored ? "/logo/logo-text-1-color.svg" : "/logo/logo-text-1.svg";
  const t2 = colored ? "/logo/logo-text-2-color.svg" : "/logo/logo-text-2.svg";
  return (
    <div
      className={`relative h-[32px] w-[167px] overflow-hidden ${
        variant === "light" ? "[&_img]:brightness-0 [&_img]:invert" : ""
      } ${className}`}
      aria-label="AUTOPILOT.RU"
    >
      <div className="absolute inset-[0_80.86%_0_0]">
        <Image src={mark} alt="AUTOPILOT" fill className="block max-w-none" />
      </div>
      <div className="absolute inset-[14.67%_0_44.16%_24.64%]">
        <Image src={t1} alt="" fill className="block max-w-none" />
      </div>
      <div className="absolute inset-[65.74%_3.01%_12.19%_24.64%]">
        <Image src={t2} alt="" fill className="block max-w-none" />
      </div>
    </div>
  );
}
